import React, { useCallback, useEffect, useState } from "react";
import { array, bool, number, object, string } from "prop-types";

import LeftArrowButton from "../../atoms/icons/left-arrow-button";
import Icons from "../../icons";
import Carousel from "../../molecules/Carousel";
import CarouselItem from "../../atoms/Carouseltem";
import Anchor from "../../atoms/Anchor";
import CustomSlider from "../../atoms/CustomSlider";

import { removeHtml } from "../../utils/utils";
import { staticTexts } from "../../utils/Translate";

import "./slide-show.m.css";

const SlideShow = ({
  elements,
  lang,
  showPlayPauseBtn = false,
  isInfinite = false,
  interval = null,
  hideDisableIcon = true,
  showProgressBar = false,
  isArrow = global.isDesktop,
  showCaptionArrow = true,
  imageClickable = false,
  story = {},
  slideNumOpen,
  isPopup = true,
  widths = [250, 480, 800],
}) => {
  elements = elements?.filter((el) => el?.type === "image");

  if (!elements?.length) return null;

  const [showCarousel, setShowCarousel] = useState(false);
  const [showCaption, setShowCaption] = useState(true);
  const [carouselPosition, setCarouselPosition] = useState();
  const [currentSlide, setCurrentSlide] = useState(0);

  const showCarouselHandler = useCallback((e) => {
    if (imageClickable) return;

    setShowCarousel(true);
    setCarouselPosition({
      "--top": e.screenY + "px",
      "--left": e.screenX + "px",
      "--innerHeight": window && window.innerHeight + "px",
    });
  });

  const children = elements.map((item, index) => {
    const { url, headline } = story;

    return imageClickable ? (
      <Anchor key={index} aria-label={headline} href={url}>
        <CarouselItem element={item} clickImage={showCarouselHandler} widths={widths} />
      </Anchor>
    ) : (
      <CarouselItem key={index} element={item} clickImage={showCarouselHandler} widths={widths} />
    );
  });

  const caption = () => {
    const { title = "", "image-attribution": attribution } = elements[currentSlide] || {};
    const titleWithoutHtml = removeHtml(title);
    const attributionWithoutHtml = removeHtml(attribution);
    const hasCaption = titleWithoutHtml || attributionWithoutHtml;
    const [isMoreCaption, setIsMoreCaption] = useState(false);

    useEffect(() => {
      setIsMoreCaption(titleWithoutHtml.length > 200);
    }, [currentSlide]);

    return (
      <>
        {hasCaption && showCaption && (
          <figcaption className="image-caption" styleName="slider-image-caption">
            {showCaptionArrow && (
              <span
                styleName="down"
                onClick={(e) => {
                  e.stopPropagation();
                  setShowCaption(false);
                }}
              >
                <Icons type="arrow-down" />
              </span>
            )}

            <div styleName="slider-caption-base" className="caption-base">
              {isMoreCaption ? (
                <>
                  {titleWithoutHtml.slice(0, 200)}
                  <div styleName="is-more" onClick={() => setIsMoreCaption(false)}>
                    ...{staticTexts(lang).loadMore}
                  </div>
                </>
              ) : (
                <>
                  {titleWithoutHtml}
                  {attributionWithoutHtml && (
                    <span
                      className="image-attribute-slideshow"
                      styleName={`image-attribute ${titleWithoutHtml ? "bar" : ""}`}
                    >
                      {attributionWithoutHtml}
                    </span>
                  )}
                </>
              )}
            </div>
          </figcaption>
        )}
        {!showCaption && showCaptionArrow && (
          <span styleName="up" onClick={() => setShowCaption(true)}>
            <LeftArrowButton opacity="var(--opacity-100)" color2="var(--white)" />
          </span>
        )}
      </>
    );
  };

  return (
    <>
      <div styleName="wrapper" className="slide-show">
        <div styleName="slider">
          <CustomSlider
            setCurrentSlide={setCurrentSlide}
            currentSlide={currentSlide}
            isPopup={isPopup}
            isPagination={false}
            isNavigation={isArrow}
            isAutoplay={isInfinite}
            interval={interval}
            slideNumOpen={slideNumOpen}
            showProgressBar={showProgressBar}
            showPlayPauseBtn={showPlayPauseBtn}
            slidesPerView={{ mobileSlides: 1, tabSlides: 1, desktopSlides: 1 }}
            spacing={{ mobileSpace: 0, tabSpace: 0, desktopSpace: 0 }}
            showSlideNumber={true}
            hideDisableIcon={hideDisableIcon}
            storySlug={story.slug}
          >
            {children}
          </CustomSlider>
          {caption()}
        </div>
      </div>

      {showCarousel && carouselPosition && (
        <Carousel
          position={carouselPosition}
          closeEvent={() => setShowCarousel(false)}
          elements={elements}
          setCurrentSlide={setCurrentSlide}
          currentSlide={currentSlide}
        />
      )}
    </>
  );
};

SlideShow.propTypes = {
  elements: array,
  lang: string,
  showPlayPauseBtn: bool,
  isInfinite: bool,
  interval: number,
  hideDisableIcon: bool,
  showProgressBar: bool,
  isArrow: bool,
  showCaptionArrow: bool,
  imageClickable: bool,
  story: object,
  slideNumOpen: number,
  isPopup: bool,
  widths: array,
};

export default SlideShow;
